import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CascoComparisonDetail, CascoComparisonLabel } from '../FlowCheckStyles';

const CardProperty = ({ data, label, color }) => {
  const { t } = useTranslation();
  const isNumeric = useMemo(() => typeof data.value === 'number', [data.value]);

  return (
    <Grid item container xs={12} mt={0.25}>
      <Grid item xs={12} sm={6} md={5}>
        <CascoComparisonLabel>{label}:</CascoComparisonLabel>
      </Grid>
      <Grid item xs={12} sm={6} md={7} container>
        <CascoComparisonDetail title={data.value} changed={data.changed} changedColor={color}>
          {data.value ? (isNumeric ? t('DECIMAL2', { number: data.value }) : data.value) : 'N/A'}
        </CascoComparisonDetail>
      </Grid>
    </Grid>
  );
};

CardProperty.propTypes = {
  data: PropTypes.object,
  label: PropTypes.string,
  color: PropTypes.string
};

export default CardProperty;
